/* istanbul ignore file */
import React, { useLayoutEffect, useState } from 'react';
import { GetTeamByIdResponse2 } from '../../../api-service/clients';
import { moduleClientFactory } from '../../../api-service/module-client-factory';
import { useApi } from '../../../hooks/use-api';
import { ReadonlyInput } from '../../readonly-input/readonly-input';
import { LookupAutocomplete } from '../components/lookup-autocomplete';
import { formatTeam, renderTeam } from './formatters';
import { ITeamLookup, ITeamLookupProps } from './interfaces';
import { useFetch } from './useFetch';

export function TeamLookup(props: ITeamLookupProps) {
  const { onChange, value, fetchMinimumInputLength = 2, label = 'Team', placeholder = 'Fremsøg team', readOnly, includeInactiveTeams, ...rest } = props;

  const [selectedValue, setSelectedValue] = useState<ITeamLookup>({} as ITeamLookup);
  const [searchValue, setSearchValue] = useState('');

  function handleOnChange(selected: ITeamLookup) {
    onChange && onChange(selected?.id);
  }

  const lookupsClient = moduleClientFactory.createLookupTeamClient();
  const lookupSingleEntityApi = useApi((cancelToken, teamId) => lookupsClient.getTeamById({ teamId }, cancelToken), {} as GetTeamByIdResponse2);

  useLayoutEffect(() => {
    if (!value) {
      setSelectedValue({} as ITeamLookup);
      return;
    }
    async function getSingle() {
      const response = await lookupSingleEntityApi.invoke(value);
      if (response.result.team) {
        setSelectedValue(response.result.team);
      }
    }
    getSingle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const { data, loading } = useFetch(searchValue, fetchMinimumInputLength, !!includeInactiveTeams, undefined);
  return readOnly ? (
    <ReadonlyInput error={rest.error} errorText={rest.errorText} label={label} value={formatTeam(selectedValue)} />
  ) : (
    <LookupAutocomplete<ITeamLookup>
      {...rest}
      label={label}
      placeholder={placeholder}
      isOptionEqualToValue={(option, val) => option?.id === val?.id}
      getOptionLabel={formatTeam}
      renderOption={renderTeam}
      onChange={handleOnChange}
      value={selectedValue}
      onSearchValueChange={setSearchValue}
      data={data}
      isLoading={loading || lookupSingleEntityApi.isLoading}
    />
  );
}
